import {
  getAvailableIdentifiers,
  getAllDiagnosisNames,
  getSelectedIdentifier,
  getAllMeasureNames,
} from "../../api/calls";

type Response = {
  selectedIdentifier: string;
  availableIdentifiers: Record<string, string>;
  allDiagnosisNames: string[];
  allMeasureNames: string[];
};

/**
 * Call this once on app start
 * 
 * @param signal Abort signal
 * @returns Initial bundle
 */
export const loadInitialBundle = async (signal?: AbortSignal): Promise<Response> => {
  const [
    selectedIdentifier,
    availableIdentifiers,
    allDiagnosisNames,
    allMeasureNames,
  ] = await Promise.all([
    getSelectedIdentifier(signal),
    getAvailableIdentifiers(signal),
    getAllDiagnosisNames(signal),
    getAllMeasureNames(signal),
  ]);

  return {
    selectedIdentifier,
    availableIdentifiers,
    allDiagnosisNames,
    allMeasureNames,
  };
};
